module.exports = __webpack_public_path__ + "img/lookout-icon-2.7a8537de.svg";